import React, { useState, useEffect } from "react";
import { DatePicker, Drawer, Icon, notification, Form, Switch, Tooltip } from "antd";
import axios from "axios";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerDataLimite = ({ Id, visible, onClose, code, form }) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [dataLimite, setDataLimite] = useState();
    const [aplicar, setAplicar] = useState(false);

    useEffect(() => {
        if (visible) {
            buscarDataLimite();
        }
    }, [visible]);

    const guardar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setLoading(true);

                axios
                    .post("/api/turma/alterar-data-limite-avaliacao", {
                        avaliacaoId: Id,
                        data: data.format("YYYY-MM-DD"),
                        aplicar: aplicar
                    })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Data alterada com sucesso!");
                        onClose();
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Erro ao alterar a data.");
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        });
    };

    const buscarDataLimite = () => {
        axios.get("/api/turma/data-limite-avaliacao", {
                params: {
                    turmaId: localStorage.getItem("codigo_curso"),
                    code: code
                }
            })
            .then(response => {
                setDataLimite(response.data.dataAlterarNota);
            })
            .catch(error => {});
    };

    const handleDateChange = date => {
        setData(date);
    };

    const handleChangeAplicar = value => {
        setAplicar(value);
    };

    const afterVisibleChange = aberto => {
        if (aberto) {
            form.resetFields();
            setData("");
            setAplicar(false);
        }
    };

    const { getFieldDecorator } = form;

    return (
        <>
            <Drawer
                title="Modificar data final para lançar notas"
                className="drawer-add-cursos drawer-logs"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <Form className="form-categorias" layout="horizontal">
                    <div className="bloco">
                        <span className="dataLimite">Data limite preenchimento: {new Date(dataLimite).toLocaleDateString("pt-BR")}</span>
                        <Form.Item>
                            {getFieldDecorator("data", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: data
                            })(<DatePicker size={"large"} placeholder="Selecionar" format="DD-MM-YYYY" onChange={handleDateChange} />)}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator("aplicar", {
                                initialValue: aplicar
                            })(
                                <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <Switch size="small" checked={aplicar} onChange={handleChangeAplicar} />
                                    Aplicar a todas as avaliações
                                    <Tooltip
                                        className="info-icon"
                                        title="A data limite será alterada para todas as avaliações nesta disciplina."
                                    >
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        </Form.Item>
                    </div>
                </Form>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" onClick={guardar} disabled={loading} type="primary">
                        {loading ? <Icon type="loading" /> : null}
                        Guardar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

const FormDrawerDataLimite = Form.create({ name: "form-drawer-data-limite" })(DrawerDataLimite);

export default FormDrawerDataLimite;
